
export default {
  name: 'Instagram',
}
